import { render, staticRenderFns } from "./ManageBagsAddBags.vue?vue&type=template&id=25f20b2e&"
import script from "./ManageBagsAddBags.vue?vue&type=script&lang=js&"
export * from "./ManageBagsAddBags.vue?vue&type=script&lang=js&"
import style0 from "./ManageBagsAddBags.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ManageBagsAddBags.vue"
export default component.exports